
import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FAQSection from './FAQKeyword';
import Testimonialskeyword from './TestimonialKeyword';
function BUsbookingforweddinginpune() {



    const cardData =
    {
        keyword: '  Bus booking for wedding in Pune',
        heading: 'Samarth Travels:  Bus booking for wedding in Pune',
        headingDescription: 'Samarth Travels offers bus booking for weddings in Pune, perfect for guest transportation, bridal parties, and family travel during wedding celebrations. Our fleet includes spacious 32-seater and 45-seater buses, equipped with air-conditioning, push-back seats, and comfortable interiors to ensure a smooth and elegant ride. With punctual drivers, transparent pricing, and reliable service, Samarth Travels makes wedding transportation hassle-free and comfortable for all your guests.',

        top: 'Top Places to Visit in Pune Outstation with Samarth Travels',

      "topPlaces": [
    {
      "title": "Mahabaleshwar",
      "description": "Nestled in the Western Ghats, Mahabaleshwar is a scenic hill station around 120 km from Pune. Known for its lush strawberry farms, panoramic viewpoints like Arthur’s Seat and Wilson Point, and the historic Mahabaleshwar Temple, it offers a cool and refreshing retreat. Boating on Venna Lake and walking through misty trails make it a perfect weekend getaway."
    },
    {
      "title": "Lonavala & Khandala",
      "description": "Just about 65 km from Pune, the twin hill stations of Lonavala and Khandala are famous for their lush valleys, waterfalls, and forts like Rajmachi and Lohagad. The monsoon season enhances their charm, drawing travelers for trekking, picnics, and chikki shopping. Bhushi Dam and Tiger’s Leap are must-visit attractions in this green paradise."
    },
    {
      "title": "Shirdi",
      "description": "Located approximately 200 km from Pune, Shirdi is a revered pilgrimage town dedicated to Sai Baba. The Sai Baba Temple complex attracts millions of devotees each year. Besides the temple, other spots like Dwarkamai, Chavadi, and the Sai Heritage Village offer spiritual solace and insights into the saint’s life and teachings."
    },
    {
      "title": "Lavasa",
      "description": "Lavasa is a planned hill city about 60 km from Pune, offering Italian-style architecture and lakeside promenades. Popular for romantic getaways and weekend breaks, Lavasa features adventure sports, nature trails, and serene boat rides on the Warasgaon Lake. Its colorful buildings and vibrant cafes make it a photogenic escape."
    },
    {
      "title": "Alibaug",
      "description": "Alibaug is a coastal town around 140 km from Pune, known for its clean beaches and colonial forts. With attractions like Alibaug Beach, Kolaba Fort, and Mandwa Beach, it's a great destination for beach lovers. It’s ideal for water sports, seafood cuisine, and short family trips by road or ferry from Mumbai."
    },
    {
      "title": "Nashik",
      "description": "About 210 km from Pune, Nashik is a blend of spirituality and wine tourism. It’s home to the sacred Godavari River, Trimbakeshwar Temple, and Muktidham, making it a major religious center. Simultaneously, vineyards like Sula and York offer wine tasting and stunning vineyard views, making it a unique dual-experience destination."
    },
    {
      "title": "Kolhapur",
      "description": "Located 230 km from Pune, Kolhapur is rich in heritage, known for the Mahalaxmi Temple, New Palace Museum, and rankala Lake. It’s also famed for its spicy cuisine and handcrafted Kolhapuri chappals. A perfect cultural and culinary escape, Kolhapur provides a deep dive into Maharashtrian traditions."
    },
    {
      "title": "Bhimashankar",
      "description": "Approximately 110 km from Pune, Bhimashankar is a sacred Jyotirlinga shrine nestled in dense forests of the Sahyadri hills. Ideal for spiritual seekers and nature lovers, the region also forms part of a wildlife sanctuary. Trekking trails, misty landscapes, and temple architecture make it a soul-soothing destination."
    },
    {
      "title": "Matheran",
      "description": "Located about 120 km from Pune, Matheran is Asia’s only automobile-free hill station. Famous for its red-soiled paths, vintage toy train, and viewpoints like Panorama Point and Echo Point, it’s a tranquil retreat amidst nature. Horse rides and eco-friendly travel make it a unique experience."
    },
    {
      "title": "Goa",
      "description": "Though around 450 km away, Goa is a top outstation pick from Pune for those seeking beaches, nightlife, and Portuguese charm. From serene South Goa beaches like Palolem to lively North Goa spots like Baga and Anjuna, it’s perfect for parties, watersports, and cultural explorations. The drive or train journey adds to the adventure."
    }
  ],

  "services": [
    {
      "name": "Bus Rental for Wedding",
      "description": "Samarth Travels provides bus rentals for weddings in Pune. Whether you need transport for guests or the wedding party, our buses offer comfort, space, and punctual service to ensure everyone arrives in style."
    },
    {
      "name": "Wedding Bus Hire Near Me Pune",
      "description": "Looking for a wedding bus near you in Pune? Samarth Travels offers hassle-free wedding bus hire services with convenient locations for quick pickups and drop-offs, ensuring your guests travel comfortably."
    },
    {
      "name": "Shuttle Rental for Wedding in Pune",
      "description": "We offer shuttle rentals for weddings in Pune, providing efficient transportation solutions for your guests between venues. Our shuttle buses come with comfortable seating and experienced drivers to ensure smooth travel."
    },
    {
      "name": "Wedding Party Bus Rental",
      "description": "Celebrate in style with our wedding party bus rentals. Perfect for the bridal party or out-of-town guests, our buses feature spacious seating, premium interiors, and the best amenities to make your wedding day even more memorable."
    },
    {
      "name": "Wedding Bus Transportation in Pune",
      "description": "Ensure smooth transportation for your wedding guests with our wedding bus services in Pune. We provide a range of buses, including AC and non-AC, to suit different group sizes and budgets."
    },
    {
      "name": "Party Bus for Wedding",
      "description": "Add a fun element to your wedding with our party buses for wedding events. These buses are equipped with music systems, luxurious interiors, and ample space to ensure your wedding journey is as exciting as the event itself."
    },
    {
      "name": "Bus for Wedding Travels",
      "description": "Rent a bus for wedding travels with Samarth Travels. Whether you're transporting guests to the venue, for a destination wedding, or between locations, our buses offer comfort, style, and safe travel."
    },
    {
      "name": "Bus Booking for Wedding",
      "description": "Book your wedding transportation with Samarth Travels. We offer easy bus booking services for weddings in Pune, with flexible options to cater to the specific needs of your wedding logistics."
    },
    {
      "name": "Bus on Rent for Wedding in Pimpri Chinchwad",
      "description": "If you're in Pimpri Chinchwad, Samarth Travels offers reliable wedding bus rentals. Whether it's for guests or bridal party transportation, our buses ensure punctual service and comfort for your special day."
    },
    {
      "name": "Bus Rental for Wedding Near Me",
      "description": "Looking for wedding bus rental services nearby? Samarth Travels provides flexible bus rentals for weddings, ensuring your guests travel conveniently from one venue to the next with ease and comfort."
    },
    {
      "name": "AC Bus Booking for Marriage",
      "description": "Choose Samarth Travels for AC bus bookings for your marriage events. Our air-conditioned buses offer luxury and comfort for your guests, ensuring a pleasant travel experience throughout the event."
    },
    {
      "name": "Full Bus Booking for Marriage Price",
      "description": "Samarth Travels offers competitive pricing for full bus bookings for marriage events. With a range of bus sizes available, you can choose the perfect option based on your needs and budget."
    },
    {
      "name": "Pune to Outstation Bus Booking for Marriage",
      "description": "Planning a wedding at an outstation venue? Book a bus from Pune to your wedding destination. Samarth Travels offers comfortable and reliable outstation bus rentals for marriage events, ensuring your guests travel in style."
    },
    {
      "name": "Bus Booking for Marriage Event",
      "description": "Make your marriage event stress-free with Samarth Travels' bus booking services. We provide efficient transportation for wedding guests, from local to outstation venues, with guaranteed comfort and punctuality."
    }
  ],
  "tableData": [
    ["Bus Rental for Wedding", "Wedding Bus Hire Near Me Pune"],
    ["Shuttle Rental for Wedding in Pune", "Wedding Party Bus Rental"],
    ["Wedding Bus Transportation in Pune", "Party Bus for Wedding"],
    ["Bus for Wedding Travels", "Bus Booking for Wedding"],
    ["Bus on Rent for Wedding in Pimpri Chinchwad", "Bus Rental for Wedding Near Me"],
    ["AC Bus Booking for Marriage", "Full Bus Booking for Marriage Price"],
    ["Pune to Outstation Bus Booking for Marriage", "Bus Booking for Marriage Event"]
  ],


"whychoose": [
    {
        "WhyChooseheading": "Reliable Bus Rental Service for Weddings in Pune",
        "WhyChoosedescription": "We offer reliable and professional bus rental services for weddings in Pune. Whether it’s transporting guests to the venue, or ensuring smooth transfers between venues, we provide seamless and efficient transportation, allowing you to focus on enjoying your special day."
    },
    {
        "WhyChooseheading": "Spacious and Comfortable Buses for Wedding Guests",
        "WhyChoosedescription": "Our buses provide ample seating with comfortable arrangements, air-conditioning, and generous legroom to ensure your wedding guests travel in comfort. We offer a variety of bus sizes, including large coaches and smaller minibuses, to accommodate all your guests."
    },
    {
        "WhyChooseheading": "Experienced Drivers for Smooth Wedding Logistics",
        "WhyChoosedescription": "Our skilled and professional drivers are trained to handle wedding transportation logistics with care. They ensure timely pick-up and drop-off, providing guests with a smooth and hassle-free travel experience between venues, including ceremony sites, reception halls, and hotels."
    },
    {
        "WhyChooseheading": "Affordable and Transparent Pricing for Wedding Bus Rentals",
        "WhyChoosedescription": "We offer affordable and transparent pricing for wedding bus rentals, with no hidden charges. Our flexible rental packages can be tailored to suit your budget, ensuring a cost-effective transportation solution for your wedding day without compromising on quality."
    },
    {
        "WhyChooseheading": "24/7 Availability for Wedding Day Flexibility",
        "WhyChoosedescription": "Our bus rental services are available 24/7, providing flexibility to fit your wedding schedule. Whether your ceremony is in the morning, afternoon, or evening, we ensure timely arrivals and departures for all your wedding transportation needs."
    },
    {
        "WhyChooseheading": "Hassle-Free Booking Process and Real-Time Updates for Coordination",
        "WhyChoosedescription": "Booking a bus for your wedding is simple and quick. After booking, you’ll receive real-time tracking updates, driver contact details, and vehicle arrival notifications, ensuring that you can manage all logistics with ease and confidence on your big day."
    },
    {
        "WhyChooseheading": "Clean, Sanitized, and Well-Maintained Buses for Your Wedding",
        "WhyChoosedescription": "We maintain our buses to the highest standards of cleanliness and safety. Each bus is thoroughly cleaned and sanitized before every trip, providing a hygienic environment for your wedding guests and ensuring their comfort and safety throughout the journey."
    },
    {
        "WhyChooseheading": "Multiple Payment Options for Easy and Secure Booking",
        "WhyChoosedescription": "We offer multiple easy payment methods including UPI, credit/debit cards, digital wallets, and cash, making it convenient for you to complete your wedding bus booking securely."
    }
]


















    }

const faqData = [
    {
        id: 1,
        question: 'How can I book a bus for a wedding in Pune with Samarth Travels?',
        answer: 'Booking a bus for a wedding in Pune is simple with Samarth Travels. Contact us through our website or phone, and share your wedding schedule, number of guests, and pickup/drop points. We’ll arrange the ideal vehicle to suit your needs.',
    },
    {
        id: 2,
        question: 'What types of buses are available for wedding transportation?',
        answer: 'We offer a variety of buses including 22-seater, 32-seater, 40-seater, and 50-seater options. You can choose between AC and Non-AC buses based on guest comfort and budget. All buses come with clean interiors and comfortable seating.',
    },
    {
        id: 3,
        question: 'Can I book multiple buses for different wedding events?',
        answer: 'Yes, we can arrange multiple buses for your sangeet, mehendi, wedding, and reception functions. We offer flexible scheduling and route planning to ensure timely guest transport between venues.',
    },
    {
        id: 4,
        question: 'Can pickup and drop-off points be customized for guests?',
        answer: 'Absolutely. We allow complete customization of pickup and drop-off locations, whether it’s from hotels, residences, or wedding venues. We ensure all your guests travel comfortably and arrive on time.',
    },
    {
        id: 5,
        question: 'What are the charges for wedding bus rentals in Pune?',
        answer: 'Bus rental rates start from ₹35/km and vary depending on the size, type, and duration. We also offer full-day packages with fixed hours and distance limits. Contact us for a quote tailored to your wedding requirements.',
    },
    {
        id: 6,
        question: 'Is the bus decorated for weddings?',
        answer: 'On request, we can arrange simple floral or ribbon decorations for wedding buses. For more elaborate decor, we can coordinate with your event planner to ensure the vehicle fits your wedding theme.',
    },
    {
        id: 7,
        question: 'Is support available during the wedding transport service?',
        answer: 'Yes, Samarth Travels provides 24/7 support to ensure your wedding transportation runs smoothly. Our team is available for any last-minute route adjustments or coordination with your event team.',
    },
];

const testimonials = [
    {
        name: 'Mr. Rakesh Shah',
        role: 'Father of the Bride',
        text: 'We hired two 40-seater buses from Samarth Travels for my daughter’s wedding in Pune. The buses were clean, punctual, and very comfortable for our guests. Their team coordinated everything perfectly.',
        image: '/img/testimonial/testi_wedding_rakesh.jpg',
    },
    {
        name: 'Ms. Kavita Bhosale',
        role: 'Wedding Planner',
        text: 'Samarth Travels is my go-to for wedding transport in Pune. They’re reliable, professional, and always on time. The buses are well-maintained and perfect for large guest groups.',
        image: '/img/testimonial/testi_wedding_kavita.jpg',
    },
];





































    const contactData = {
        heading: `${cardData.keyword} Contact Number`,
        contactNumbers: [
            "+91 9860256019",
            "+91 9527500025",

        ],
        email: "samarthtravels9119@gmail.com"
    };


   const Images = [
        {
            place: "/images/keyword/1.jpg",
            text: " Tempo Traveller Pune",
        },
        {
            place: "/images/keyword/2.jpg",
            text: " Tempo Traveller on Rent Pune",
        },
        {
            place: "/images/keyword/3.jpg",
            text: " Bus on Rent in Pune",
        },
        {
            place: "/images/keyword/4.jpg",
            text: " Tempo Traveller on Rent",
        },
        {
            place: "/images/keyword/5.jpg",
            text: " Tempo Traveller Rent in Pune",
        },
        {
            place: "/images/keyword/6.jpg",
            text: " Tempo Traveller Hire in Pune",
        },
        {
            place: "/images/keyword/7.jpg",
            text: " Mini Bus for Rent",
        },

        {
            place: "/images/keyword/8.jpg",
            text: " Bus on Rent Hire",
        },

        {
            place: "/images/keyword/9.jpg",
            text: " Bus on Rent Pune",
        },
        {
            place: "/images/keyword/10.jpg",
            text: " Bus Rental in Pune",
        },

        {
            place: "/images/keyword/11.jpg",
            text: " Hire Tempo Traveller",
        },
        {
            place: "/images/keyword/12.jpg",
            text: " Bus Hire in Pune",
        },
        {
            place: "/images/keyword/13.jpg",
            text: " Ac Tempo Traveller Rent Pune",
        },
        {
            place: "/images/keyword/14.jpg",
            text: " Bus Hire For Outstation",
        },
        {
            place: "/images/keyword/15.jpg",
            text: " Bus on Rent for Local",
        },
        {
            place: "/images/keyword/16.jpg",
            text: " Bus Rental For Wedding",
        },
        {
            place: "/images/keyword/17.jpg",
            text: "Bus Rent for Marriage",
        },
        {
            place: "/images/keyword/18.jpg",
            text: " Bus Rental For Corporate Events",
        },
        {
            place: "/images/keyword/19.jpg",
            text: "  Bus Rental for Tour",
        },

        {
            place: "/images/keyword/20.jpg",
            text: "Bus Rental For Corporate in Pune",
        },
        {
            place: "/images/keyword/21.jpg",
            text: " Tempo Traveller on Rent in Pune",
        },
        {
            place: "/images/keyword/22.jpg",
            text: " AC Bus On Rent",
        },
        {
            place: "/images/keyword/23.jpg",
            text: " Non Ac Bus Rental Service",
        },
        {
            place: "/images/keyword/24.jpg",
            text: "Bus on Hire on Pune to Mahabaleshwar Package Tour ",
        },
        {
            place: "/images/keyword/25.jpg",
            text: "Bus Hire for Picnic",
        },
    ];


    const images = [
        { src: "/images/fleets/1.jpg", alt: "Image 1" },
        { src: "/images/fleets/2.jpg", alt: "Image 1" },
        { src: "/images/fleets/3.jpg", alt: "Image 1" },
        { src: "/images/fleets/4.jpg", alt: "Image 1" },
        { src: "/images/fleets/5.jpg", alt: "Image 1" },
        { src: "/images/fleets/6.jpg", alt: "Image 1" },
        { src: "/images/fleets/7.jpg", alt: "Image 1" },
        { src: "/images/fleets/8.jpg", alt: "Image 1" },
        { src: "/images/fleets/9.jpg", alt: "Image 1" },


    ];




const productSchema = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Bus Booking for Wedding in Pune",
  "image": "https://samarthtravels.com/assets/images/wedding-bus-booking-pune.jpg", // Replace with actual image URL
  "description": "Book buses for weddings in Pune with Samarth Travels. Perfect for wedding parties, guest transportation, and marriage events. AC and Non-AC buses available, offering comfort and convenience for large groups.",
  "brand": {
    "@type": "Brand",
    "name": "Samarth Travels"
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "bestRating": "5",
    "worstRating": "1",
    "ratingValue": "4.9",
    "ratingCount": "6523"
  },
  "offers": {
    "@type": "Offer",
    "priceCurrency": "INR",
    "price": "9500",
    "availability": "https://schema.org/InStock",
    "url": "https://samarthtravels.com/bus-booking-for-wedding-pune" // Replace with actual page URL
  }
};





    return (
        <div>


<Helmet>
  <title>Bus Booking for Wedding in Pune | Wedding Bus Hire & Shuttle Rentals</title>
  <meta 
    name="description" 
    content="Book buses for weddings in Pune with Samarth Travels. Affordable and reliable wedding transportation services with AC & Non-AC buses. Perfect for wedding parties, guest travel, and marriage events." 
  />
  <meta 
    name="keywords" 
    content="Bus Rental for wedding, Wedding bus hire near me Pune, Shuttle rental for wedding in Pune, wedding party bus rental, wedding bus transportation in Pune, Party Bus for Wedding, Bus for wedding Travels, Bus booking for wedding, bus on rent for wedding in Pimpri Chinchwad, Bus Rental for wedding near me, Ac bus booking for marriage, full bus booking for marriage price, Pune to outstation bus booking for marriage, Bus Booking for Marriage Event" 
  />
  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>
</Helmet>

            <div className="breadcumb-wrapper" data-bg-src="/images/breadcumb-bg.jpg">
                <div className="container">
                    <div className="breadcumb-content">
                        <h1 className="breadcumb-title text-center">{cardData.keyword}</h1>
                    </div>
                </div>
            </div>



            <section>
                <div className="container-fluid" >
                    <div className="row container-fluid">
                        <div className="col-12 col-md-7 bg-foootr">
                            <img src='/images/keyword/61.jpg' alt='img' />
                            <h3 className="py-1"
                                style={{
                                    color: '#322E77', // Red color for the title 
                                    textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                                    fontWeight: 'bold'
                                }}


                            >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
                            <div className="">
                                <p className='fw-bold py-3 darkcolorrr'>{cardData.top}</p>
                                {cardData.topPlaces.map((place, index) => (
                                    <div key={index} className="">
                                        <div
                                            style={{
                                                cursor: 'pointer',
                                                padding: '10px',
                                                marginBottom: '7px',
                                                borderRadius: '8px',
                                                transition: 'transform 0.2s'
                                            }}

                                        >
                                            <h4 className="mb-1 darkcolorrr">{place.title}</h4>
                                            <p className="mb-0">{place.description}</p>
                                        </div>
                                    </div>
                                ))}
                            </div>
                            <div
                                style={{
                                    cursor: 'pointer',
                                    padding: '10px',
                                    marginBottom: '7px',
                                    borderRadius: '8px', // Optional: rounded corners
                                    transition: 'transform 0.2s' // Optional: smooth scaling effect
                                }}
                            >
                                {cardData.services.map((service, index) => (
                                    <div key={index} className=" my-4">
                                        <h4 className="py-1 darkcolorrr">{service.name}</h4>
                                        <p>{service.description}</p>
                                    </div>
                                ))}
                            </div>

                            <table className="table table-responsive Border-key my-2">
                                <tbody className=' Border-key'>
                                    {cardData.tableData.map((row, rowIndex) => (
                                        <tr className='Border-key ' key={rowIndex}>
                                            {row.map((cell, cellIndex) => (
                                                <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                                            ))}
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                            <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
                            <BusRatesTable />

                            <div id="why-choose-section"
                                className='px-2 bg-foootr'>
                                {cardData.whychoose.map((item, index) => (
                                    <div key={index}>
                                        <h4 className="py-1 whycolor">{item.WhyChooseheading}</h4>
                                        <p>{item.WhyChoosedescription}</p>
                                    </div>
                                ))}
                            </div>


                            <div className="row twm-faq-section-1 m-b30">


                                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                                    <div className="twm-faq-info-wrap">

                                        <div className="section-head left">
                                            <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Samarth Travels </h2>
                                        </div>


                                        <div className="twm-faq-info">
                                            <div className="accordion twm-acdn" id="sf-faq-accordion">


                                                <FAQSection faqs={faqData} accordionId="drivingAccordion" />

                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>


                            <Testimonialskeyword
                                data={testimonials}
                                title="What Our Clients Are Saying"
                                subtitle="Customer Feedback"
                            />


                            <div className='py-4'>

                                <div className="contact-box Borderr">
                                    <h3>{contactData.heading}</h3>
                                    <p className='text-black'>For booking inquiries or any assistance, please feel free to contact us:</p>
                                    <div className="contact-details">
                                        <p><strong className='darkcolor'>Mobile No:</strong></p>
                                        <ul>
                                            {contactData.contactNumbers.map((number, index) => (
                                                <li key={index}>
                                                    <a href={`tel:${number}`} className="contact-link fw-bold fs-5">
                                                        {number}
                                                    </a>
                                                </li>
                                            ))}
                                        </ul>
                                        <p><strong className='darkcolor'>Email Id: </strong>
                                            <a href={`mailto:${contactData.email}`} className="contact-link">
                                                {contactData.email}
                                            </a>
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className='col-12 col-md-4' >
                            {Images.map((e) => {
                                return (
                                    <div className="box1">
                                        <a
                                            href="./"
                                            className="d-flex justify-content-around align-items-center"
                                        >
                                            <div className="b1">
                                                <img src={e.place} alt="img" />
                                            </div>
                                            <div className="b2">
                                                {" "}
                                                <a href="./" className='px-3'>{e.text}</a>
                                            </div>
                                        </a>
                                    </div>
                                );
                            })}


                            <div className="gallery-container">
                                <h2 className="gallery-title">Our Fleets</h2>
                                <div className="gallery-row d-flex flex-wrap">
                                    {images.map((image, index) => (
                                        <div className="gallery-item col-md-4" key={index}>
                                            <img
                                                src={image.src}
                                                alt={image.alt}
                                                className="gallery-image"

                                            />
                                        </div>
                                    ))}

                                </div>
                            </div>

                            <div className=" rounded p-4 shadow-sm Uni_border "
                                style={{
                                    cursor: 'pointer',
                                    padding: '10px',
                                    border: '3px dotted #FF8F1F',
                                    marginBottom: '7px',
                                    fontWeight: 'bold',
                                }}

                            >
                                <h4 className="pb-3 pt-3 lead fw-bold text-dark">Contact Information</h4>

                                <div className="row">

                                    <div className="col-12 mb-3">
                                        <div className="Small_border  rounded text-center py-2 " style={{ backgroundColor: '#FF8F1F' }}>
                                            <h4 className=" lead fw-semibold whitt textt-dark">Phone Numbers</h4>
                                            <i className="bi bi-telephone-fill fs-1 mb-2"></i>
                                            <div className=''>
                                                <a href="tel:+919860256019" className="d-block  text-white">+91 9860256019</a>
                                                <a href="tel:+919527500025" className="d-block  text-white">+91 9527500025</a>


                                            </div>
                                        </div>
                                    </div>


                                    <div className="col-12 mb-3 ">
                                        <div className="Small_border rounded text-center">
                                            <i className="bi bi-envelope fs-1 mb-2"></i>
                                            <div className='rounded py-2' style={{ backgroundColor: '#FF8F1F' }}>
                                                <h4 className=" fw-semibold lead whitt textt-dark">Email</h4>
                                                <a href="mailto:samarthtravels9119@gmail.com" className=" text-white d-block">
                                                    samarthtravels9119@gmail.com
                                                </a>
                                            </div>
                                        </div>
                                    </div>


                                    <div className="col-12 mb-3 ">
                                        <div className="Small_border  rounded text-center">
                                            <i className="bi bi-house-fill fs-1 mb-2"></i>
                                            <div className='rounded py-2' style={{ backgroundColor: '#FF8F1F' }}>
                                                <h4 className=" fw-semibold lead whitt textt-dark">Address</h4>
                                                <p className="whit text-white ">
                                                    <i> Samarth Travels <br />
                                                        Flat no 201, Juhi Building, Suyash Shrushti Society, Tukai darshan Hadapsar, Pune- 411028
                                                    </i>
                                                </p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>


                        </div>
                    </div>
                </div>
            </section>


        </div>
    );
}

export default BUsbookingforweddinginpune;